import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Box, HStack, Spacer, Text, useMediaQuery } from "native-base";
import InputField from "../../../../components/input";
import { MOBILE_VIEW_WIDTH } from "../../../../utils/screens";
import DateInputField from "../../../../components/dateInput";
import FormHeader from "../../../../components/formHeader";
import NewTextAreaField from "../../../../components/textArea/newTextArea";
import { COMMONFONTWEIGHT } from "../../../../utils/fonts";
import FileUploader from "../../../../containers/fileUpload";
import ViewUploadImageCards from "../../../../containers/viewUploadImageCards";

const EventDetails = forwardRef(
  (
    {
      eventFormData,
      setEventFormData,
      eventErrorFormData,
      setDefaultErrorFrom,
      forceRemount,
      childref,
      showModal,
      edit = false,
    },
    ref
  ) => {
    const [MobileWindow] = useMediaQuery({
      maxWidth: MOBILE_VIEW_WIDTH,
    });
    const [eventUpdateFormData, setEventUpdateFormData] =
      useState(eventFormData);
    const [selectedFiles, setSelectedFiles] = useState([]);

    useEffect(() => {
      if (showModal) {
        let data = { ...eventUpdateFormData };
        let dataKeys = [
          "estimated_budget",
          "event_location",
          "event_name",
          "from_date",
          "other_requirements",
          "to_date",
          "about_event",
          "banner",
        ];
        Object.keys(eventUpdateFormData).map((key) => {
          if (!dataKeys.includes(key)) delete data[key];
        });
        setEventUpdateFormData(data);
      } else setEventUpdateFormData(eventFormData);
      if (eventUpdateFormData["banner"].length !== 0 && !edit) {
        const imageUrls = Array.from(eventUpdateFormData["banner"]).map(
          (item) => URL.createObjectURL(item)
        );
        setSelectedFiles(imageUrls);
      }
    }, []);

    const onInputChange = (e, eName) => {
      setDefaultErrorFrom();
      let value = e.target.value;
      let detail = { ...eventUpdateFormData };
      if (eName === "estimated_budget" && isNaN(value)) {
        return;
      }
      detail[eName] = value;
      setEventUpdateFormData(detail);
    };
    const onSubmitDataInput = () => {
      return eventUpdateFormData;
    };

    useImperativeHandle(ref, () => ({
      onSubmitDataInput,
    }));

    const handleFilesSelect = (file) => {
      const imageUrls = Array.from(file).map((item) =>
        URL.createObjectURL(item)
      );
      setSelectedFiles(imageUrls);
      let detail = { ...eventUpdateFormData };
      detail["banner"] = file;
      setEventUpdateFormData(detail);
    };

    const onDeleteImage = (ind) => {
      setSelectedFiles([]);
      let detail = { ...eventUpdateFormData };
      detail["banner"] = [];
      setEventUpdateFormData(detail);
    };

    return (
      <>
        {!edit && <FormHeader text="Event Detail" />}
        <Spacer axis="X" size={4}></Spacer>

        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="event_name"
              value={
                eventFormData.event_name === ""
                  ? eventUpdateFormData.event_name
                  : eventFormData.event_name
              }
              label="Event Name"
              placeholder="Enter Event Name"
              onChange={onInputChange}
              isInvalid={eventErrorFormData.event_name}
              errorMessage={eventErrorFormData.event_name}
              important
              forceRemount={forceRemount}
              ref={childref}
              isDisabled={edit && true}
            />
          </Box>
          <Box flex={1}>
            <InputField
              name="event_location"
              value={
                eventFormData.event_location === ""
                  ? eventUpdateFormData.event_location
                  : eventFormData.event_location
              }
              onChange={onInputChange}
              label="Event Location"
              placeholder="Enter Event Location"
              isInvalid={eventErrorFormData.event_location}
              errorMessage={eventErrorFormData.event_location}
              forceRemount={forceRemount}
              ref={childref}
            />
          </Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <DateInputField
              name="from_date"
              onChange={onInputChange}
              defaultValue={eventUpdateFormData.from_date}
              label="Event From Date"
              placeholder="Select Event From Date"
              isInvalid={eventErrorFormData.from_date}
              errorMessage={eventErrorFormData.from_date}
              toDate={eventUpdateFormData.to_date}
              important
            />
          </Box>
          <Box flex={1}>
            <DateInputField
              name="to_date"
              onChange={onInputChange}
              defaultValue={eventUpdateFormData.to_date}
              label="Event To Date"
              placeholder="Select Event To Date"
              isInvalid={eventErrorFormData.to_date}
              errorMessage={eventErrorFormData.to_date}
              fromDate={eventUpdateFormData.from_date}
              important
            />
          </Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="estimated_budget"
              value={
                eventFormData.estimated_budget === ""
                  ? eventUpdateFormData.estimated_budget
                  : eventFormData.estimated_budget
              }
              onChange={onInputChange}
              label="Estimated budgets"
              placeholder="Enter Estimated budgets"
              isInvalid={eventErrorFormData.estimated_budget}
              errorMessage={eventErrorFormData.estimated_budget}
              forceRemount={forceRemount}
              ref={childref}
            />
          </Box>
          {!MobileWindow && <Box flex={1}></Box>}
        </HStack>

        {/* <Spacer axis="X" size={8}></Spacer>
        <FormHeader text="Other Requirement" /> */}
        <Spacer axis="X" size={4}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={!MobileWindow && 1}>
            <NewTextAreaField
              name="other_requirements"
              value={
                eventFormData.other_requirements === ""
                  ? eventUpdateFormData.other_requirements
                  : eventFormData.other_requirements
              }
              onChange={onInputChange}
              label="Other Requirements"
              placeholder="Enter Other Requirements"
              isInvalid={eventErrorFormData.other_requirements}
              errorMessage={eventErrorFormData.other_requirements}
              forceRemount={forceRemount}
              ref={childref}
            />
          </Box>
          <Box flex={!MobileWindow && 1}>
            <NewTextAreaField
              name="about_event"
              value={
                eventFormData.about_event === ""
                  ? eventUpdateFormData.about_event
                  : eventFormData.about_event
              }
              onChange={onInputChange}
              label="About Event"
              placeholder="Enter About Event"
              isInvalid={eventErrorFormData.about_event}
              errorMessage={eventErrorFormData.about_event}
              forceRemount={forceRemount}
              ref={childref}
            />
          </Box>
        </HStack>

        <Spacer axis="X" size={4}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={!MobileWindow && 1}>
            {!edit && (
              <>
                <Text
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                  color={"rgb(115, 115, 115)"}
                >
                  Upload Banner
                </Text>
                <FileUploader
                  files={selectedFiles}
                  show={false}
                  setFiles={handleFilesSelect}
                  accept={["png", "jpg", "jpeg"]}
                  types={".png, .jpg, .jpeg"}
                  forceRemount={forceRemount}
                  // images={true}
                />
                <HStack flex={1} flexWrap={"wrap"}>
                  {selectedFiles.length > 0 && selectedFiles[0] !== "" && (
                    <ViewUploadImageCards
                      ind={0}
                      url={selectedFiles}
                      onDeleteImage={onDeleteImage}
                    />
                  )}
                </HStack>
              </>
            )}
          </Box>
          <Box flex={1}></Box>
        </HStack>
      </>
    );
  }
);

export default EventDetails;
